import {
  ACTIVITY_CREATE_FAILED,
  ACTIVITY_CREATE_REQ,
  ACTIVITY_CREATE_SUCCESS,
  ACTIVITY_DETAILS_FAILED,
  ACTIVITY_DETAILS_REQ,
  ACTIVITY_DETAILS_SUCCESS,
  ACTIVITY_DETAILS_UPDATE_FAILED,
  ACTIVITY_DETAILS_UPDATE_REQ,
  ACTIVITY_DETAILS_UPDATE_SUCCESS,
} from "../constants/activityConstant";
import { api2 } from "../core/api";
//eventTagged tru /false
export const activityDetails = (contactId, EventTagged) => async (dispatch) => {
  try {
    dispatch({
      type: ACTIVITY_DETAILS_REQ,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.get(
      `/activities/getcontactivity/event/${contactId}/${EventTagged}`,
      config
    );

    var dt = data.Result;

    if (dt?.includes("Error")) {
      dispatch({
        type: ACTIVITY_DETAILS_FAILED,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: ACTIVITY_DETAILS_SUCCESS,
        payload: data?.Result[0],
        eventActivity: data?.eventActivity[0],
      });
    }
  } catch (error) {
    dispatch({
      type: ACTIVITY_DETAILS_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const activityCreateDetails = (Activity) => async (dispatch) => {
  try {
    dispatch({
      type: ACTIVITY_CREATE_REQ,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api2.post(`/activities`, Activity, config);

    var dt = data.Result;

    if (dt?.includes("Error")) {
      dispatch({
        type: ACTIVITY_CREATE_FAILED,
        payload: data.Result.replace("Error - ", ""),
      });
    } else {
      dispatch({
        type: ACTIVITY_CREATE_SUCCESS,
        payload: "Success !",
        contactId: data?.Result,
      });
    }
  } catch (error) {
    dispatch({
      type: ACTIVITY_CREATE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const activityUpdateDetails =
  (Activity, ActivtyId) => async (dispatch) => {
    try {
      dispatch({
        type: ACTIVITY_DETAILS_UPDATE_REQ,
      });

      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api2.put(
        `/activities/${ActivtyId}`,
        Activity,
        config
      );

      var dt = data.Result;

      if (dt?.includes("Error")) {
        dispatch({
          type: ACTIVITY_DETAILS_UPDATE_FAILED,
          payload: data.Result.replace("Error - ", ""),
        });
      } else {
        dispatch({
          type: ACTIVITY_DETAILS_UPDATE_SUCCESS,
          payload: "Success !",
          contactId: data?.Result,
        });
      }
    } catch (error) {
      dispatch({
        type: ACTIVITY_DETAILS_UPDATE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
